import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icon/icon-scan.svg'


const _withScopeId = n => (_pushScopeId("data-v-cae5a50e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "membership-id-with-qrcode" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary rounded-pill" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Scan QR code"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "icon"
  })
], -1))
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = ["src"]

import { authStore } from '@/stores';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  
return (_ctx: any,_cache: any) => {
  const _component_AppScanner = _resolveComponent("AppScanner")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_AppScanner, null, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", {
        src: _ctx.$get(_unref(authStore).user, 'qrcode.url'),
        class: "qrcode"
      }, null, 8, _hoisted_4)
    ])
  ]))
}
}

})